import {Modal, Button, Row, Form, Col, InputGroup, FloatingLabel, FormControlProps, Collapse} from 'react-bootstrap';
import React, {useEffect, useRef, useState} from 'react';

import JSONIncaricoIstituzionale from '../../../../json/system/incarico_istituzionale.json'
import JSONRegions from '../../../../json/databasecomuni/italy_regions.json'
import JSONProvincies from '../../../../json/databasecomuni/italy_provincies.json'
import JSONCities from '../../../../json/databasecomuni/italy_cities.json'
import JSONCap from '../../../../json/databasecomuni/italy_cap.json'
import JSONMultiCap from '../../../../json/databasecomuni/italy_multicap.json'


import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import CodiceFiscale from 'codice-fiscale-js';
import {
    previousYear,
    defaultQuota,
    defaultNONE,
    defaultINTPHONECODE,
    defaultNO,
    defaultEMPTY,
    defaultYES,
    defaultRoleRegionProvinceTown,
    donationMagazineQuota,
    defaultMinYoungAge,
    emailPattern
} from "../../config/global";
import {useToolkit} from "../../hooks/useToolkit";

//import PhoneInput, {  formatPhoneNumber, formatPhoneNumberIntl } from "react-phone-number-input";
//import 'react-phone-number-input/style.css'

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'


import flags from 'react-phone-number-input/flags'
import {useStockStorage} from "../../hooks/useStockStorage";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";
import {useSanctum} from "react-sanctum";
import EmailConfirmation from "../modals/EmailConfirmation";
import ZeroSubscriptions from "../modals/ZeroSubscriptions";

interface IProps {
    data: any | undefined;
    onChangeForm: (values: any) => void;
}

const SubscriptionFormEdit = ({ data, onChangeForm }: IProps) => {
    const refScrollToTop = useRef<HTMLInputElement>(null);
    const refFiscalCode = useRef<HTMLInputElement>(null);

    const { user } = useSanctum();
    let navigate = useNavigate();
    const { getQuota, getRegione, getProvincia, getComune, getAge } = useToolkit();
    const { getAppUniqueToken } = useAppUniqueToken();
    const { setStockStorageToken, removeStockStorageToken } = useStockStorage();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    // => PAYLOAD
    const [name, setName] = useState(defaultEMPTY);
    const [surname, setSurname] = useState(defaultEMPTY);
    const [fiscalCode, setFiscalCode] = useState(defaultEMPTY);
    const [email, setEmail] = useState(defaultEMPTY);
    const [email2, setEmail2] = useState(defaultEMPTY);
    const [phone, setPhone] = useState(defaultEMPTY);
    const [job, setJob] = useState(defaultEMPTY);
    const [address, setAddress] = useState(defaultEMPTY);
    const [addressCAP, setAddressCAP] = useState(defaultNONE);
    const [associazione, setAssociazione] = useState(defaultEMPTY);
    const [iscrizioneAP, setIscrizioneAP] = useState(defaultNO);
    const [incarico, setIncarico] = useState(defaultNONE);
    const [motivo, setMotivo] = useState(defaultEMPTY);
    const [sex, setSex] = useState(defaultEMPTY);
    const [regione, setRegione] = useState(defaultEMPTY);
    const [provincia, setProvincia] = useState(defaultEMPTY);
    const [comune, setComune] = useState(defaultEMPTY);
    const [comuneDecoded, setComuneDecoded] = useState(defaultEMPTY);
    const [dob, setDob] = useState(new Date());
    const [quota, setQuota] = useState(defaultQuota);
    const [donationMagazine, setDonationMagazine] = useState(undefined);
    const [sessionStockName] = useState(getAppUniqueToken);
    const [gev, setGev] = useState(undefined);

    //const [subscriptionValue, setSubscriptionValue] = useState(quota);
    const [uaToken] = useState(getAppUniqueToken);
    const [jsonRegion, setJSONRegion] = useState(JSONRegions.italy_regions);
    const [jsonProvince, setJSONProvince] = useState(JSONProvincies.italy_provincies);
    const [jsonCity, setJSONCity] = useState(JSONCities.italy_cities);
    const [jsonCap, setJSONCap] = useState(JSONCap.italy_cap);
    const [jsonMultiCap, setJSONMultiCap] = useState(JSONMultiCap.italy_multicap);
    const [isMultiCAP, setIsMultiCAP] = useState(false);

    const [subscriptionCount, setSubscriptionCount] = useState(0);
    const [errorDefault, setErrorDefault] = useState(defaultEMPTY);
    const [showEmailConfirmationModal, setShowEmailConfirmationModal] = useState(false);
    const [showZeroSubscriptionsModal, setShowZeroSubscriptionsModal] = useState(false);
    const [showFiscalCodeConfirmationModal, setShowFiscalCodeConfirmationModal] = useState(false);
    const [fiscalCodeDuplicate, setFiscalCodeDuplicate] = useState(false);
    

    let payload = {
        name: '',
        surname: '',
        fiscalCode: '',
        email: '',
        email2: '',
        phone: '',
        job: '',
        address: '',
        addressCAP: '',
        //address2: '',
        associazione: '',
        iscrizioneAP: '',
        incarico: '',
        motivo: '',
        sex: '',
        regione: '',
        provincia: '',
        comune: '',
        subscriptionValue: defaultEMPTY,
        donationMagazine: defaultEMPTY,
        gev: defaultEMPTY
    }


    //const [form, setForm] = useState(payload)
    const [errors, setErrors] = useState(payload)
    const [formErrors, setFormErrors] = useState(payload);

    const setField = (field: any, value: any) => {
        // update UI state
        if(field === 'name') { setErrors({...errors, name: defaultEMPTY}); setName(value); }
        else if(field === 'surname') { setErrors({...errors, surname: defaultEMPTY}); setSurname(value); }
        else if(field === 'fiscalCode') { setErrors({...errors, fiscalCode: defaultEMPTY}); setFiscalCode(value); }
        else if(field === 'email') { setErrors({...errors, email: defaultEMPTY}); setEmail(value); }
        else if(field === 'email2') { setErrors({...errors, email2: defaultEMPTY}); setEmail2(value); }
        else if(field === 'phone') { setErrors({...errors, phone: defaultEMPTY}); setPhone(value); }
        else if(field === 'job') { setErrors({...errors, job: defaultEMPTY}); setJob(value); }
        else if(field === 'address') { setErrors({...errors, address: defaultEMPTY}); setAddress(value); }
        else if(field === 'addressCAP') { setErrors({...errors, addressCAP: defaultEMPTY}); setAddressCAP(value); }
        else if(field === 'iscrizioneAP') { setErrors({...errors, iscrizioneAP: defaultEMPTY}); setIscrizioneAP(value); }
        else if(field === 'incarico') { setErrors({...errors, incarico: defaultEMPTY}); setIncarico(value); }
        else if(field === 'motivo') { setErrors({...errors, motivo: defaultEMPTY}); setMotivo(value); }
        else if(field === 'sex') { setErrors({...errors, sex: defaultEMPTY}); setSex(value); }
        else if(field === 'regione') { setErrors({...errors, regione: defaultEMPTY}); setRegione(value); }
        else if(field === 'provincia') { setErrors({...errors, provincia: defaultEMPTY}); setProvincia(value); }
        else if(field === 'comune') { setErrors({...errors, comune: defaultEMPTY}); setComune(value); }
        else if(field === 'associazione') { setErrors({...errors, associazione: defaultEMPTY}); setAssociazione(value); }
        else if(field === 'donationMagazine') { setErrors({...errors, donationMagazine: defaultEMPTY}); setDonationMagazine(value); }
        else if(field === 'gev') { setGev(value); }

        const next = {
            incarico: field === 'incarico' ? value : incarico,
            fiscalCode: field === 'fiscalCode' ? value : fiscalCode,
            donationMagazine: field === 'donationMagazine' ? value : donationMagazine
        };

        let quota_by_incarico = parseInt(getQuota('incarico', next.incarico));
        let quota_by_fiscalcode = parseInt(getQuota('fiscalCode', next.fiscalCode));

        let q = (quota_by_incarico === 0)
            ? quota_by_fiscalcode
            : quota_by_incarico;

        if(next.donationMagazine) {
            q += parseInt(donationMagazineQuota);
        }

        setQuota(q.toString());

        const updated = {
            uaToken,
            name: field === 'name' ? value : name,
            surname: field === 'surname' ? value : surname,
            fiscalCode: next.fiscalCode,
            email: field === 'email' ? value : email,
            email2: field === 'email2' ? value : email2,
            phone: field === 'phone' ? value : phone,
            job: field === 'job' ? value : job,
            address: field === 'address' ? value : address,
            addressCAP: field === 'addressCAP' ? value : addressCAP,
            associazione: field === 'associazione' ? value : associazione,
            iscrizioneAP: field === 'iscrizioneAP' ? value : iscrizioneAP,
            incarico: next.incarico,
            motivo: field === 'motivo' ? value : motivo,
            sex: field === 'sex' ? value : sex,
            regione: field === 'regione' ? value : regione,
            provincia: field === 'provincia' ? value : provincia,
            comune: field === 'comune' ? value : comune,
            comuneDecoded,
            dob,
            quota: q.toString(),
            donationMagazine: next.donationMagazine,
            gev: field === 'gev' ? value : gev,
            [field]: value
        };

        onChangeForm(updated);
    };



    const findFormErrors = (blurField = defaultEMPTY) => {
        setFormErrors(payload);

        if (!name || name === '' || name === defaultEMPTY) { formErrors.name = t('messages.mandatoryField'); }
        if (!surname || surname === '' || surname === defaultEMPTY) { formErrors.surname = t('messages.mandatoryField'); }

        if (!fiscalCode || fiscalCode === '' || fiscalCode === defaultEMPTY)
        {
            formErrors.fiscalCode = t('messages.mandatoryField');
            if(blurField
                && blurField !== defaultEMPTY
                && blurField ===  'fiscalCode')
            {
                setErrors({...errors, fiscalCode: t('messages.mandatoryField')});
                return formErrors;
            }
        }
        else
        {
            try {
                const cf = new CodiceFiscale(fiscalCode);
            }
            catch (e) {
                formErrors.fiscalCode = t('messages.wrongFiscalCode');
                if(blurField
                    && blurField !== defaultEMPTY
                    && blurField === 'fiscalCode')
                {
                    setErrors({...errors, fiscalCode: t('messages.wrongFiscalCode')});
                    return formErrors;
                }
            }
        }

        if (!email || email === '' || email === defaultEMPTY)
        {
            formErrors.email = t('messages.mandatoryField');
            if(blurField
                && blurField !== defaultEMPTY
                && blurField ===  'email')
            {
                setErrors({...errors, email: t('messages.mandatoryField')});
                return formErrors;
            }
        }
        else {
            //if (!/\S+@\S+\.\S+/.test(email)) {
            if(emailPattern.test(email) === false) {
                formErrors.email = t('messages.invalidEmailAddress');

                if(blurField
                    && blurField !== defaultEMPTY
                    && blurField ===  'email')
                {
                    setErrors({...errors, email: t('messages.invalidEmailAddress')});
                    return formErrors;
                }
            }
        }

        if (!email2 || email2 === '' || email2 === defaultEMPTY)
        {
            formErrors.email2 = t('messages.mandatoryField');
            if(blurField
                && blurField !== defaultEMPTY
                && blurField ===  'email2')
            {
                setErrors({...errors, email2: t('messages.mandatoryField')});
                return formErrors;
            }
        }
        else {
            if (!/\S+@\S+\.\S+/.test(email2)) {
                formErrors.email2 = t('messages.invalidEmailAddress');

                if(blurField
                    && blurField !== defaultEMPTY
                    && blurField ===  'email2')
                {
                    setErrors({...errors, email2: t('messages.invalidEmailAddress')});
                    return formErrors;
                }
            }
        }

        if (email && email2 && email !== email2)
        {
            formErrors.email2 = t('messages.wrongEmailAddress');
            if(blurField
                && blurField !== defaultEMPTY
                && blurField ===  'email2')
            {
                setErrors({...errors, email2: t('messages.wrongEmailAddress')});
                return formErrors;
            }
        }

        if (!phone || phone === '' || phone === defaultEMPTY || phone === defaultINTPHONECODE)
        {
            formErrors.phone = t('messages.mandatoryField')
            if(blurField
                && blurField !== defaultEMPTY
                && blurField ===  'phone')
            {
                setErrors({...errors, phone: t('messages.mandatoryField')});
                return formErrors;
            }
        }
        if (!sex || sex === '' || sex === defaultEMPTY) { formErrors.sex = t('messages.mandatoryField') }
        if (!regione || regione === '' || regione === defaultEMPTY || regione === defaultNONE) { formErrors.regione = t('messages.mandatoryField') }
        if (!provincia || provincia === '' || provincia === defaultEMPTY || provincia === defaultNONE) { formErrors.provincia = t('messages.mandatoryField') }
        if (!comune || comune === '' || comune === defaultEMPTY || comune === defaultNONE) { formErrors.comune = t('messages.mandatoryField') }
        if (!addressCAP || addressCAP === '' || addressCAP === defaultEMPTY || addressCAP === defaultNONE) { formErrors.addressCAP = t('messages.mandatoryField') }
        if (!address || address === '' || address === defaultEMPTY) { formErrors.address = t('messages.mandatoryField') }

        return formErrors
    }

    const formReset = () => {
        setErrors({...errors, name: defaultEMPTY}); setName(defaultEMPTY);
        setErrors({...errors, surname: defaultEMPTY}); setSurname(defaultEMPTY);
        setErrors({...errors, fiscalCode: defaultEMPTY}); setFiscalCode(defaultEMPTY);
        setErrors({...errors, email: defaultEMPTY}); setEmail(defaultEMPTY);
        setErrors({...errors, email2: defaultEMPTY}); setEmail2(defaultEMPTY);
        setErrors({...errors, phone: defaultEMPTY}); setPhone(defaultEMPTY); setPhone(defaultINTPHONECODE);
        
        setErrors({...errors, job: defaultEMPTY}); setJob(defaultEMPTY);
        setErrors({...errors, address: defaultEMPTY}); setAddress(defaultEMPTY);

        setErrors({...errors, addressCAP: defaultEMPTY}); setAddressCAP(defaultNONE);
        setErrors({...errors, associazione: defaultEMPTY}); setAssociazione(defaultEMPTY);
        setErrors({...errors, iscrizioneAP: defaultEMPTY}); setIscrizioneAP(defaultNO);

        setErrors({...errors, incarico: defaultEMPTY}); setIncarico(defaultNONE);

        setErrors({...errors, motivo: defaultEMPTY}); setMotivo(defaultEMPTY);
        setErrors({...errors, sex: defaultEMPTY}); setSex(defaultEMPTY);
        setErrors({...errors, regione: defaultEMPTY}); setRegione(defaultEMPTY);
        setErrors({...errors, provincia: defaultEMPTY}); setProvincia(defaultEMPTY);
        setErrors({...errors, comune: defaultEMPTY}); setComune(defaultEMPTY);
        
        setDob(new Date());
        setQuota(defaultQuota);

        setErrors({...errors, donationMagazine: defaultEMPTY}); setDonationMagazine(undefined);
        setGev(undefined);
        
        
        setErrorDefault(defaultEMPTY);
    }

   
    const checkUserAuthorization = (): boolean => {
        if(!defaultRoleRegionProvinceTown)
            return true;
        else {
            if(user)
            {
                let userRegion = user.user.system_region;
                let userProvince = user.user.system_province;
                let userTown = user.user.system_town;

                //console.log('userRegion: ' + userRegion + ' -> regione: '+ regione);
                //console.log('userProvince: ' + userProvince+ ' -> provincia: '+ provincia);
                //console.log('userTown: ' + userTown+ ' -> comune: '+ comune);

                if(userRegion && userRegion != regione)
                {
                    toast.error(t('messages.errorWrongRegion'));
                    return false;
                }

                if(userProvince && userProvince != provincia)
                {
                    toast.error(t('messages.errorWrongProvince'));
                    return false;
                }

                if(userTown && userTown != comune)
                {
                    toast.error(t('messages.errorWrongTown'));
                    return false;
                }

                return true;
            }

            toast.error(t('messages.errorUser'));
            return false;
        }
    };

    function handleSubmit(e: any, action: string){

        const f = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();

        const er = findFormErrors()
        if (Object.values(er).filter(x => x !== defaultEMPTY).length > 0 ) {
            //alert('findFormErrors: '+ Object.values(er).filter(x => x !== '').length);
            setErrors(er)
            setErrorDefault(t('messages.defaultMandatoryFieldsCheck').toString());

            window.scroll(0, 0);
        }
        else {
            if (f.checkValidity()) {
                if(checkUserAuthorization())
                {
                    const payload = {
                        uaToken,
                        //subscriptionValue,
                        quota,
                        name,
                        surname,
                        fiscalCode,
                        email,
                        email2,
                        phone,
                        job,
                        address, addressCAP,
                        //address2,
                        associazione,
                        iscrizioneAP,
                        incarico,
                        motivo,
                        sex,
                        regione,
                        provincia,
                        comune,
                        comuneDecoded,
                        dob
                    };

                    axios.post('/api/insert', payload, {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }).then(response => {
                        if(action === 'summary')
                        {
                            setStockStorageToken(uaToken);
                            navigate('/summary');
                        }
                        else
                        {
                            setSubscriptionCount(response.data.subscriptions_count);
                            window.location.reload();
                            window.scroll(0, 0);
                        }
                    }).catch(error => {
                        toast.error(t('messages.defaultErrorMessage'));
                    });
                }
            }
        }
    }


    function handlePersonEmailCheck(emailValue: string) {
        //console.log('handlePersonEmailCheck: ' + emailValue);
        findFormErrors('email');

        //console.log('errors.email: ' + errors.email);
        //console.log('errors.email2: ' + errors.email2);

        if(emailValue
            && emailValue !== ''
            && emailValue !== defaultEMPTY
            && (!errors.email || (errors.email == '' || errors.email === defaultEMPTY))
            && (!errors.email2 || (errors.email2 == '' || errors.email2 === defaultEMPTY))
        )
        {
            const payload = {
                uaToken,
                emailValue
            };

            axios.post('/api/person-email', payload, {
                headers: {
                    'Accept': 'application/json'
                }
            }).then(response => {
                //toast.info(t('email trovata'));
                //console.log('response:');
                //console.log(response);

                setShowEmailConfirmationModal(response.data.person_email_found);
            }).catch(error => {
                toast.error(t('messages.defaultErrorMessage'));
            });
        }
    }

    /*
    let submitRef: React.MutableRefObject<null> | any = useRef(null);
    let resetRef: React.MutableRefObject<null> | any = useRef(null);
    useEffect(() => {
        //if (!submitForm) {
        //    submitForm(submitRef);
        //    submitRef = handleSubmit;
        //}
        submitForm(submitRef);
        submitRef = handleGoToSummary;


        //if (!resetForm) {
        //    resetForm(resetRef);
        //    resetRef = handleReset;
        //}
        resetForm(resetRef);
        resetRef = handleSubmitThisOne;

        //console.log(getRegione('1'));

    }, []);
    */


    useEffect(() => {
        console.log('useEffect - form.regione: ' + regione);

/*
        setField('provincia', defaultEMPTY);
        setField('comune', defaultEMPTY);
        setField('addressCAP', defaultEMPTY);

*/
        console.log('useEffect - regione: loading - ' + loading);
        if(loading)
            return;

        if(regione && regione !== defaultNONE && regione !== defaultEMPTY)
        {
            setJSONProvince(JSONProvincies.italy_provincies.filter(x => x.id_regione === regione));
            const p = JSONRegions.italy_regions.find(x => x.id_regione === regione);
            if(p)
            {
                var r = p?.regione;
                setJSONCity(JSONCities.italy_cities.filter(x => x.regione === r));
                setIsMultiCAP(false);
            }
        }
        else
            setJSONProvince(JSONProvincies.italy_provincies);
    }, [regione])
    useEffect(() => {
        //console.log('useEffect - form.provincia: ' + provincia);
        if(loading)
            return;
        
        if(provincia && provincia !== defaultNONE && provincia !== defaultEMPTY)
        {
            setJSONCity(JSONCities.italy_cities.filter(x => x.provincia === provincia));
            setIsMultiCAP(false);
        }
        else
            setJSONCity(JSONCities.italy_cities);

    }, [provincia])
    useEffect(() => {
        //console.log('useEffect - form.comune: ' + comune);
        if(loading)
            return;
        
        if(comune && comune !== defaultNONE && comune !== defaultEMPTY)
        {
            // regione": "Piemonte
            // "provincia": "TO",


            let mCAP = JSONMultiCap.italy_multicap.filter(x => x.istat === comune);
            if(mCAP.length > 0)
            {
                setIsMultiCAP(true);
                setJSONMultiCap(mCAP);
            }
            else
            {
                setIsMultiCAP(false);
                const p = JSONCap.italy_cap.find(x => x.istat === comune);
                if(p)
                {
                    setField('addressCAP', p?.cap);
                }
            }
        }
        else
            setField('addressCAP', defaultNONE);

    }, [comune])

    useEffect(() => {
        try {
            const cf = new CodiceFiscale(fiscalCode);


            if(!incarico || incarico === defaultNONE)
                setQuota(getQuota('fiscalCode', fiscalCode));


            //console.log(cf.toJSON());

            // => SEX REGIONE PROVICIA COMUNE
            //console.log('sex: ' + cf.gender);
            //setSex(cf.gender);
            setField('sex', cf.gender);
            setDob(cf.birthday);

            //birthplace: "NAPOLI",
            //birthplaceProvincia: "NA"
            //console.log('comune: ' + cf.birthplace);

            //console.log(cf.toJSON().birthplaceProvincia);
            //setJSONProvincia(getProvincia(cf.toJSON().birthplaceProvincia))

            /*
            const p = JSONProvincies.italy_provincies.find(x => x.sigla === cf.toJSON().birthplaceProvincia);
            //console.log(p);
            if(p)
            {
                setField('regione', p.id_regione);
                setField('provincia', p.sigla);
            }
            */
        } catch (e) {
            //setField('sex', '');
        }
    }, [fiscalCode])

    // useEffect(() => {
    //     setQuota(getQuota('incarico', incarico));
    //     //setSubscriptionValue(quota);
    // }, [incarico])

    // useEffect(() => {
    //     let q = calculateCurrentQuote();

    //     /*
    //     console.log('useEffect - donationMagazine - getCurrentQuote: ' + JSON.stringify(q));

    //     let r = donationMagazineQuota;
    //     if(donationMagazine) {
    //         r = (q + parseInt(donationMagazineQuota)).toString();
    //     }
    //     else {
    //         if(q > 0)
    //             r = (q - parseInt(donationMagazineQuota)).toString();
    //         else 
    //             r = q.toString();
    //     }

    //     setQuota(r);
    //     */

    // }, [donationMagazine])

    // useEffect(() => {
    //     window.scroll(0, 0);
    //     setQuota(getQuota('incarico', incarico));
    //     //setSubscriptionValue(quota);
    // }, [])

    useEffect(() => {
        if(data)
        {
            setLoading(true);  
            
            console.log('data in SubscriptionFormEdit:');
            console.log(JSON.stringify(data));

            // <td>{ item.subscription_value
            //loadForm();
            
            //setLoading(false);  
        }
    }, [data])

    useEffect(() => {
        if(loading)
        {
           console.log('loading: ' + loading);
            loadForm();
            
        }
    }, [loading])

    function loadForm(){
        console.log('loadForm');

        setName(data.person_name ? data.person_name : defaultEMPTY);
            setSurname(data.person_surname ? data.person_surname : defaultEMPTY);
            setFiscalCode(data.person_fiscal_code ? data.person_fiscal_code : defaultEMPTY);
            setEmail(data.person_email ? data.person_email : defaultEMPTY);
            setEmail2(data.person_email ? data.person_email : defaultEMPTY);
            setPhone(data.person_phone_number ? data.person_phone_number : defaultEMPTY);
            setJob(data.person_job ? data.person_job : defaultEMPTY);
            setAddress(data.person_address ? data.person_address : defaultEMPTY);
            
            setAssociazione(data.person_association ? data.person_association : defaultEMPTY);
            setIscrizioneAP(data.person_previously_subscribed ? data.person_previously_subscribed : defaultNO);
            setIncarico(data.person_public_role ? data.person_public_role : defaultNONE);
            setMotivo(data.person_association_motive ? data.person_association_motive : defaultEMPTY);
            setSex(data.person_sex ? data.person_sex : defaultEMPTY);
            
            setRegione(data.person_region ? data.person_region : defaultEMPTY);
            setProvincia(data.person_province ? data.person_province : defaultEMPTY);
            setComune(data.person_town_istat ? data.person_town_istat : defaultEMPTY);
            setComuneDecoded(data.person_town ? data.person_town : defaultEMPTY);
            let mCAP = JSONMultiCap.italy_multicap.filter(x => x.istat === data.person_town_istat);
            if(mCAP.length > 0)
            {
                setIsMultiCAP(true);
                setJSONMultiCap(mCAP);
            }
            else
            {
                setIsMultiCAP(false);
                const p = JSONCap.italy_cap.find(x => x.istat === data.person_town_istat);
                if(p)
                {
                    setField('addressCAP', p?.cap);
                }
            }
            setAddressCAP(data.person_cap ? data.person_cap : defaultNONE);
            
            setDob(data.person_dob ? new Date(data.person_dob) : new Date());
            setQuota(data.subscription_value ? data.subscription_value : defaultQuota);
    
            setLoading(false);  
    }


    const handleOnChangeRegion = (e: any) => {
        if(loading)
            return;

        setField('regione', e.target.value);

        setField('provincia', defaultEMPTY);
        setField('comune', defaultEMPTY);
        setField('addressCAP', defaultEMPTY);
    }
    const handleOnChangeProvince = (e: any) => {
        if(loading)
            return;

        setField('provincia', e.target.value);
    }
    const handleOnChangeTown = (e: any) => {
        if(loading)
            return;

        setField('comune', e.target.value);
    }
    const handleOnChangeMotive = (e: any) => {
        if(loading)
            return;

        setField('motivo', e.target.value)

        if(e.target.value === 'MOTIVO-RESIDENZA')
            setField('associazione', comuneDecoded);
    }

    const calculateCurrentQuote = () => {
    
        let cq = 0;

        let quota_by_incarico = parseInt(getQuota('incarico', incarico));
        //alert('quota_by_incarico: ' + quota_by_incarico)
        
        let quota_by_fiscalcode =  parseInt(getQuota('fiscalCode', fiscalCode));
        //alert('quota_by_fiscalcode: ' + quota_by_fiscalcode)
        //console.log('quota_by_fiscalcode: ' + quota_by_fiscalcode)
        //cq = quota_by_incarico + quota_by_fiscalcode;

        if(quota_by_incarico == 0) {
            cq = quota_by_fiscalcode;
        }
        else {
            cq = quota_by_incarico;
        }

        //alert('cq: ' + cq)
        //alert('donationMagazine: ' + JSON.stringify(donationMagazine))

        if(donationMagazine){
            if(donationMagazine) {
                cq += parseInt(donationMagazineQuota);
            }
            else {
                cq -= parseInt(donationMagazineQuota);
            }
        }

        /*
        if(donationMagazine) {
            cq += parseInt(donationMagazineQuota);
        }
        else {
            cq -= parseInt(donationMagazineQuota);
        }
        */
        
        //alert('cq: ' + cq)

        // setCurrentQuote(cq);
        setQuota(cq.toString());

        return cq;
    };

    const handleHideFiscalCodeConfirmationModal = () => {
        
        //refFiscalCode.current?.focus();

        setShowFiscalCodeConfirmationModal(false);
        
    };
    const handlFiscalCodeBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>, fcValue: string) => {
        
        //console.log('handlePersonEmailCheck: ' + emailValue);
        findFormErrors('fiscalCode');

        //console.log('errors.email: ' + errors.email);
        //console.log('errors.email2: ' + errors.email2);

        if(fcValue
            && fcValue !== ''
            && fcValue !== defaultEMPTY
        )
        {
            const payload = {
                uaToken,
                fiscalCode: fcValue
            };

            axios.post('/api/person-fiscalcode', payload, {
                headers: {
                    'Accept': 'application/json'
                }
            }).then(response => {
                //toast.info(t('email trovata'));
                //console.log('response:');
                //console.log(response);

                if(response.data.person_fiscal_code_found) {
            
                    
                    //alert(e.relatedTarget)
                    e.preventDefault();
                    e.stopPropagation();

                    //refFiscalCode.current?.focus();

                    setFiscalCodeDuplicate(true);
                }
                else {
                    setFiscalCodeDuplicate(false);
                }

                setShowFiscalCodeConfirmationModal(response.data.person_fiscal_code_found);
                
                

            }).catch(error => {
                console.log(JSON.stringify(error));
                toast.error(t('messages.defaultErrorMessage'));
            });
        }

    };

    let labelGEV = <>
        Avendo meno di 36 anni desidero far parte dell’organizzazione giovanile denominata
        &nbsp;<b>“GIOVANI EUROPEISTI VERDI"</b>, partecipare alle iniziative, ricevere comunicazioni di appuntamenti e riunioni.
        <br /><br />
        <span className="small">*Spuntare la casella se si vuole far parte dei <b>GIOVANI EUROPEISTI VERDI (GEV)</b></span>
    </>
    return (
        <>
            <Form noValidate >
                                        <center><p className={'text-danger'}>{errorDefault}</p></center>
                                        <Row className="mt-1">
                                            <Form.Group as={Col} controlId="validation_Name">
                                                <FloatingLabel
                                                    controlId="floating_Name"
                                                    label={t('labels.name*')}
                                                    className="mb-3"
                                                >
                                                    <Form.Control required
                                                                  maxLength={30}
                                                                  type="text"
                                                                  placeholder={t('labels.name*').toString()}
                                                                  value={name}
                                                                  onFocus={() => {
                                                                    setErrors({...errors, name: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                            refFiscalCode.current?.focus()
                                                                  }}
                                                                  onChange={e => setField('name', e.target.value.toUpperCase())}
                                                                   onInput={(e) => { e.currentTarget.value = e.currentTarget.value.toUpperCase();}}
                                                                  isInvalid={!!errors.name}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group as={Col} controlId="validation_Surname">
                                                <FloatingLabel
                                                    controlId="floating_Surname"
                                                    label={t('labels.surname*')}
                                                    className="mb-3"
                                                >
                                                    <Form.Control required
                                                                  maxLength={30}
                                                                  type="text"
                                                                  placeholder={t('labels.surname*').toString()}
                                                                  value={surname}
                                                                  onChange={e => { setField('surname', e.target.value.toUpperCase())}}
                                                                   onInput={(e) => { e.currentTarget.value = e.currentTarget.value.toUpperCase();}}
                                                                  onFocus={() => {
                                                                    setErrors({...errors, surname: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                    }}
                                                                  isInvalid={!!errors.surname}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1 mb-3">
                                            <Form.Group as={Col} controlId="validation_FiscalCode" className="mb-3">
                                                <FloatingLabel
                                                    controlId="floating_FiscalCode"
                                                    label={t('labels.fiscalCode*')}
                                                >
                                                    <Form.Control required
                                                                  type="text"
                                                                  placeholder={t('labels.fiscalCode*').toString()}
                                                                  value={fiscalCode}
                                                                  onChange={e => setField('fiscalCode', e.target.value.toUpperCase())}
                                                                   onInput={(e) => { e.currentTarget.value = e.currentTarget.value.toUpperCase();}}
                                                                  onFocus={() => setErrors({...errors, fiscalCode: defaultEMPTY})}
                                                                  isInvalid={!!errors.fiscalCode}
                                                                  onBlur={(e) => {

                                                                        //alert(fiscalCode)

                                                                        //findFormErrors('fiscalCode');
                                                                        handlFiscalCodeBlur(e, fiscalCode);
                                                                   
                                                                    //handlePersonFiscalCodeCheck(fiscalCode);
                                                                  }}
                                                                  ref={refFiscalCode}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{errors.fiscalCode}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>

                                            <Collapse
                                                in={
                                                    !!(sex
                                                    && sex !== defaultEMPTY
                                                    && fiscalCode
                                                    && fiscalCode !== defaultEMPTY
                                                    && dob
                                                    && getAge(dob).years <= defaultMinYoungAge)
                                                }
                                                key={"clpGEV"}
                                            >
                                                <Row className="mb-3 mx-0">
                                                    <Form.Group as={Col} controlId="gGEV" className="p-1 px-2 border-success border-3 rounded-3 bg-success-subtle">
                                                        <Form.Check
                                                            //readOnly={xApp.isGEV}
                                                            checked={gev}
                                                            //disabled={xApp.isGEV}
                                                            //defaultChecked={xApp.isGEV}
                                                            className="small"
                                                            label={labelGEV}
                                                            type="checkbox"
                                                            id="chk-GEV"
                                                            onChange={e => setField('gev', e.target.checked)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                            </Collapse>

                                            <Form.Label id={'infoQuota'} className={'small'}>Importo totale richieste inserite finora viene aggiornato in automatico dopo l'inserimento del codice fiscale (Quota ordinaria 10 € superiore a 26 anni)</Form.Label>
                                            
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group as={Col} controlId="validation_Email">
                                                <FloatingLabel
                                                    controlId="floating_Email"
                                                    label={t('labels.mail*')}
                                                    className="mb-3"
                                                >
                                                    <Form.Control required
                                                                  type="email"
                                                                  placeholder={t('labels.mail*').toString()}
                                                                  value={email}
                                                                  onChange={e => setField('email', e.target.value)}
                                                                  onFocus={() => {
                                                                    setErrors({...errors, email: defaultEMPTY})
  
                                                                        if(fiscalCodeDuplicate)
                                                                            refFiscalCode.current?.focus()

                                                                    }}
                                                                  isInvalid={!!errors.email}
                                                                  onBlur={() => handlePersonEmailCheck(email)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group as={Col} controlId="validation_Email2">
                                                <FloatingLabel
                                                    controlId="floating_Email2"
                                                    label={t('labels.mailRepeat*')}
                                                    className="mb-3"
                                                >
                                                    <Form.Control required
                                                                  type="email"
                                                                  placeholder={t('labels.mailRepeat*').toString()}
                                                                  value={email2}
                                                                  onChange={e => setField('email2', e.target.value)}
                                                                  onFocus={() => {
                                                                    setErrors({...errors, email2: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                }}
                                                                  isInvalid={!!errors.email2}
                                                                  onBlur={() => findFormErrors('email2')}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{errors.email2}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group as={Col} controlId="validation_Phone" className="mb-3">
                                                <Form.Label className={'float-left'}>{t('labels.mobile*')}</Form.Label>
                                                <PhoneInput
                                                    country='it'
                                                    inputProps={{
                                                        name: 'phone',
                                                        required: true
                                                    }}
                                                    placeholder={t('labels.mobile*').toString()}
                                                    value={phone}
                                                    onChange={e => setField('phone', e)}
                                                    onFocus={() => {
                                                        setErrors({...errors, phone: defaultEMPTY})
                                                        if(fiscalCodeDuplicate)
                                                            refFiscalCode.current?.focus()
                                                    }}
                                                    disableDropdown={true}
                                                    inputStyle={{
                                                        width: "100%",
                                                        height: "56px"
                                                    }}
                                                    onBlur={() => findFormErrors('phone')}
                                                />
                                                <Form.Label className={'float-left text-danger small'}>{errors.phone}</Form.Label>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group as={Col} controlId="job">
                                                <FloatingLabel
                                                    controlId="floating_Job"
                                                    label={t('labels.job')}
                                                    className="mb-3"
                                                >
                                                    <Form.Control type="text"
                                                                  maxLength={30}
                                                                  placeholder={t('labels.job').toString()}
                                                                  value={job}
                                                                  onChange={e => setField('job', e.target.value.toUpperCase())}
                                                                   onInput={(e) => { e.currentTarget.value = e.currentTarget.value.toUpperCase();}}
                                                                  onFocus={() => {
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                }}
                                                    />
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group as={Col} controlId="validation_SEX">
                                                <Form.Label>{t('labels.sex*')}</Form.Label>
                                                <Form.Check required label={t('labels.sex_type.female')} name="rdoSEX" type="radio" id="radio-F"
                                                            value={'F'}
                                                            onChange={e => setField('sex', e.target.value.toUpperCase())}
                                                            onFocus={() => {
                                                                setErrors({...errors, sex: defaultEMPTY})
                                                                if(fiscalCodeDuplicate)
                                                                    refFiscalCode.current?.focus()
                                                            }}
                                                            onClick={(e) => {
                                                                if(fiscalCodeDuplicate) {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    refFiscalCode.current?.focus()
                                                                }   
                                                            }}
                                                            isInvalid={!!errors.sex}
                                                            checked={sex === 'F'}
                                                />
                                                <Form.Check required label={t('labels.sex_type.male')} name="rdoSEX" type="radio" id="radio-M"
                                                            value={'M'}
                                                            onChange={e => setField('sex', e.target.value.toUpperCase())}
                                                            onFocus={() => {
                                                                setErrors({...errors, sex: defaultEMPTY})
                                                                if(fiscalCodeDuplicate)
                                                                    refFiscalCode.current?.focus()
                                                            }}
                                                            onClick={(e) => {
                                                                if(fiscalCodeDuplicate) {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    refFiscalCode.current?.focus()
                                                                }   
                                                            }}
                                                            isInvalid={!!errors.sex}
                                                            checked={sex === 'M'}
                                                />
                                                <Form.Check required label={t('labels.sex_type.noAnswer')} name="rdoSEX" type="radio" id="radio-U"
                                                            value={'N'}
                                                            onChange={e => setField('sex', e.target.value.toUpperCase())}
                                                            onFocus={() => {
                                                                setErrors({...errors, sex: defaultEMPTY})
                                                                if(fiscalCodeDuplicate)
                                                                    refFiscalCode.current?.focus()
                                                            }}
                                                            onClick={(e) => {
                                                                if(fiscalCodeDuplicate) {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    refFiscalCode.current?.focus()
                                                                }   
                                                            }}
                                                            isInvalid={!!errors.sex}
                                                            checked={sex === 'N'}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.sex}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mt-3 mb-3">
                                            <Form.Group md="4" as={Col} controlId="validation_REGIONE">
                                                <FloatingLabel
                                                    controlId="floating_REGIONE"
                                                    label={t('labels.region*')}
                                                    className="mb-3"
                                                >
                                                    <Form.Select required

                                                                 value={regione}
                                                                 onChange={e => handleOnChangeRegion(e)}
                                                                 onFocus={() => {
                                                                    setErrors({...errors, regione: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                }}
                                                                onClick={(e) => {
                                                                    if(fiscalCodeDuplicate) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        refFiscalCode.current?.focus()
                                                                    }   
                                                                }}
                                                                 isInvalid={!!errors.regione}
                                                                 aria-label="floating_REGIONE select"
                                                    >
                                                        <option key={defaultNONE} value={defaultNONE}></option>
                                                        {
                                                            jsonRegion.map(({id_regione, regione}, idx) => (
                                                                <option key={'REG' + idx} value={id_regione} >{regione}</option>
                                                            ))
                                                        }
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">{errors.regione}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                            <Form.Group as={Col} md="4" controlId="validation_PROVINCIA">
                                                <FloatingLabel
                                                    controlId="floating_PROVINCIA"
                                                    label={t('labels.province*')}
                                                    className="mb-3"
                                                >
                                                    <Form.Select required
                                                                 size="sm"
                                                                 value={provincia}
                                                                 onChange={e => handleOnChangeProvince(e)}
                                                                 onFocus={() => {
                                                                    setErrors({...errors, provincia: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                }}
                                                                onClick={(e) => {
                                                                    if(fiscalCodeDuplicate) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        refFiscalCode.current?.focus()
                                                                    }   
                                                                }}
                                                                 isInvalid={!!errors.provincia}
                                                                 aria-label="floating_PROVINCIA select"
                                                    >
                                                        <option key={defaultNONE} value={defaultNONE}></option>
                                                        {
                                                            jsonProvince.map(({sigla, provincia, id_regione}, idx) => (
                                                                <option key={'PRV' + idx} value={sigla} >{provincia}</option>
                                                            ))
                                                        }
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">{errors.provincia}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                            <Form.Group as={Col} md="4" controlId="validation_COMUNE">
                                                <FloatingLabel
                                                    controlId="floating_COMUNE"
                                                    label={t('labels.town*')}
                                                    className="mb-3"
                                                >
                                                    <Form.Select required
                                                                 size="sm"
                                                                 value={comune}
                                                                 onChange={e => handleOnChangeTown(e)}
                                                                 onFocus={() => {
                                                                    setErrors({...errors, comune: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                }}
                                                                onClick={(e) => {
                                                                    if(fiscalCodeDuplicate) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        refFiscalCode.current?.focus()
                                                                    }   
                                                                }}
                                                                 isInvalid={!!errors.comune}
                                                                 aria-label="floating_COMUNE select"
                                                    >
                                                        <option key={defaultNONE} value={defaultNONE}></option>
                                                        {
                                                            jsonCity.map(({istat, comune, provincia}, idx) => (
                                                                <option key={'COM' + idx} value={istat} >{comune}</option>
                                                            ))
                                                        }
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">{errors.comune}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mt-1">
                                            <Form.Group md="8" as={Col} controlId="validation_Address">
                                                <FloatingLabel
                                                    controlId="floating_Address"
                                                    label={t('labels.address*')}
                                                    className="mb-3"
                                                >
                                                    <Form.Control required
                                                                  type="textarea"
                                                                  placeholder={t('labels.address*').toString()}
                                                                  value={address}
                                                                  onChange={e => setField('address', e.target.value.toUpperCase())}
                                                                   onInput={(e) => { e.currentTarget.value = e.currentTarget.value.toUpperCase();}}
                                                                  onFocus={() => {
                                                                    setErrors({...errors, address: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                }}
                                                                  isInvalid={!!errors.address}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="validation_CAP">
                                                <FloatingLabel
                                                    controlId="floating_CAP"
                                                    label="CAP *"
                                                    className="mb-3"
                                                >
                                                    <Form.Select required
                                                                 size="sm"
                                                                 value={addressCAP}
                                                                 onChange={e => setField('addressCAP', e.target.value)}
                                                                 onFocus={() => {
                                                                    setErrors({...errors, addressCAP: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                }}
                                                                onClick={(e) => {
                                                                    if(isMultiCAP && fiscalCodeDuplicate) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        refFiscalCode.current?.focus()
                                                                    }   
                                                                }}
                                                                 isInvalid={!!errors.addressCAP}
                                                                 disabled={!isMultiCAP}
                                                                 aria-label="floating_CAP select"
                                                    >
                                                        <option key={defaultNONE} value={defaultNONE}></option>
                                                        {
                                                            isMultiCAP ?
                                                                jsonMultiCap.map(({istat, cap}, idx) => (
                                                                    <option key={'CAP' + idx} value={cap} >{cap}</option>
                                                                )) :
                                                                jsonCap.map(({istat, cap}, idx) => (
                                                                    <option key={'CAP' + idx} value={cap} >{cap}</option>
                                                                ))
                                                        }
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">{errors.addressCAP}</Form.Control.Feedback>
                                                </FloatingLabel>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-2">
                                            <Form.Group controlId="validation_Associazione">
                                                <FloatingLabel
                                                    controlId="floating_Associazione"
                                                    label="Associazione"
                                                >
                                                    <Form.Control required
                                                                  maxLength={128}
                                                                  type="text"
                                                                  placeholder={t('labels.association').toString()}
                                                                  value={associazione}
                                                                  onChange={e => setField('associazione', e.target.value.toUpperCase())}
                                                                  onInput={(e) => { e.currentTarget.value = e.currentTarget.value.toUpperCase();}}
                                                                  onFocus={() => {
                                                                    setErrors({...errors, associazione: defaultEMPTY})
                                                                    if(fiscalCodeDuplicate)
                                                                        refFiscalCode.current?.focus()
                                                                }}
                                                                  isInvalid={!!errors.associazione}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{errors.associazione}</Form.Control.Feedback>
                                                </FloatingLabel>
                                                <Form.Label className={'small'}>Il tesserato viene inserito automaticamente nell'associazione del comune di residenza</Form.Label>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group controlId="validation_Associazione2" 
                                                onFocus={() => {
                                                    if(fiscalCodeDuplicate)
                                                        refFiscalCode.current?.focus()
                                                }}
                                            >
                                                <Form.Label>{t('labels.association_motivation')}</Form.Label>
                                                <Form.Check label={t('labels.association_motives.study')} name="radioAssociazione2" type="radio" id="radio-STUDIO"
                                                            value={'MOTIVO-STUDIO'}
                                                            checked={motivo === 'MOTIVO-STUDIO'}
                                                            onChange={e => {
                                                                if(fiscalCodeDuplicate) {
                                                                    e.stopPropagation();
                                                                    e.preventDefault();

                                                                    refFiscalCode.current?.focus()
                                                                }  
                                                                else {
                                                                    handleOnChangeMotive(e)
                                                                } 
                                                            }} 
                                                            onFocus={() => {
                                                                if(fiscalCodeDuplicate)
                                                                    refFiscalCode.current?.focus()
                                                            }}
                                                            
                                                            />
                                                <Form.Check label={t('labels.association_motives.job')} name="radioAssociazione2" type="radio" id="radio-LAVORO"
                                                            value={'MOTIVO-LAVORO'}
                                                            checked={motivo === 'MOTIVO-LAVORO'}
                                                            onChange={e => {
                                                                if(fiscalCodeDuplicate) {
                                                                    e.stopPropagation();
                                                                    e.preventDefault();

                                                                    refFiscalCode.current?.focus()
                                                                }  
                                                                else {
                                                                    handleOnChangeMotive(e)
                                                                }
                                                            }}
                                                            onFocus={() => {
                                                                if(fiscalCodeDuplicate)
                                                                    refFiscalCode.current?.focus()
                                                            }}
                                                            />
                                                <Form.Check label={t('labels.association_motives.town')} name="radioAssociazione2" type="radio" id="radio-RESIDENZA"
                                                            value={'MOTIVO-RESIDENZA'}
                                                            checked={motivo === 'MOTIVO-RESIDENZA'}
                                                            onChange={(e) => {
                                                                if(fiscalCodeDuplicate) {
                                                                    e.stopPropagation();
                                                                    e.preventDefault();

                                                                    refFiscalCode.current?.focus()
                                                                }  
                                                                else {
                                                                    handleOnChangeMotive(e)
                                                                }
                                                            }}
                                                            onFocus={() => {
                                                                if(fiscalCodeDuplicate)
                                                                    refFiscalCode.current?.focus()
                                                            }}
                                                            />
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-3">
                                            <Form.Group className="mt-1" controlId="formIscrizioneAP"
                                            onFocus={() => {
                                                    if(fiscalCodeDuplicate)
                                                        refFiscalCode.current?.focus()
                                                }}
                                            >
                                                <Form.Label>{t('labels.previouslySubscribed')}&nbsp;{previousYear}?</Form.Label>
                                                <Form.Select
                                                    value={iscrizioneAP}
                                                    onChange={e => setField('iscrizioneAP', e.target.value)}
                                                    onClick={(e) => {
                                                        if(fiscalCodeDuplicate) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            refFiscalCode.current?.focus()
                                                        }   
                                                    }}
                                                >
                                                    <option value={defaultNO}>No</option>
                                                    <option value={defaultYES}>Si</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group className="mt-1" controlId="formIncarico">
                                                <Form.Label>{t('labels.publicRole')}</Form.Label>
                                                <Form.Select
                                                    value={incarico}
                                                    onChange={e => setField('incarico', e.target.value)}
                                                    onClick={(e) => {
                                                        if(fiscalCodeDuplicate) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            refFiscalCode.current?.focus()
                                                        }   
                                                    }}
                                                >
                                                    <option value={defaultNONE}>Nessun incarico</option>
                                                    {
                                                        //"istat": "1001",
                                                        //                         "comune": "Agliè",
                                                        //                         "regione": "Piemonte",
                                                        //                         "provincia": "TO",
                                                        //                         "prefisso": "0124",
                                                        //                         "cod_fisco": "A074",
                                                        //                         "num_residenti": "2545",
                                                        //                         "superficie": "13.28"


                                                        /*
                                                        "IncaricoIstituzionale": "Assessore regionale",
                                                        "QuotaAdesione": 350,
                                                        "IscrizioneOnLine": 1,
                                                        "Tesseramento": 1
                                                        */

                                                        JSONIncaricoIstituzionale.incarico_istituzionale
                                                            .filter(item =>
                                                                item.IscrizioneOnLine === 1
                                                                && item.Tesseramento === 1
                                                            ).map((
                                                            {
                                                                ID_IncaricoIstituzionale,
                                                                IncaricoIstituzionale,
                                                                QuotaAdesione
                                                            }, idx) => (
                                                            <option key={idx} value={ID_IncaricoIstituzionale} >{IncaricoIstituzionale}</option>
                                                        ))
                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mt-1">
                                            <Form.Group className="mt-3" controlId="gPRESS"
                                            >
                                                <Form.Check name="donationMagazine" 
                                                    label={t("labels.pressSustain")}
                                                    type="checkbox"
                                                    id="donationMagazine"
                                                    className={"small"}
                                                    checked={donationMagazine}
                                                    onChange={e => setField('donationMagazine', e.target.checked)}
                                                    onClick={(e) => {
                                                        if(fiscalCodeDuplicate) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            refFiscalCode.current?.focus()
                                                        }   
                                                    }}
                                                />
                                            </Form.Group>
                                        </Row>
                                        <Row>
                                            <Form.Group className="mt-5" controlId="labelQuota">
                                                <Form.Label>{t('labels.subscriptionQuote')}&nbsp;<b>{quota}</b></Form.Label>
                                            </Form.Group>
                                        </Row>
                                        
                                    </Form>        
            <EmailConfirmation emailField={email}
                               show={showEmailConfirmationModal}
                               onHide={() => setShowEmailConfirmationModal(false)}/>
            <ZeroSubscriptions show={showZeroSubscriptionsModal}
                               onHide={() => setShowZeroSubscriptionsModal(false)}/>
        </>
    );
};

export default SubscriptionFormEdit;